<!-- Hero Section -->
<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content text-white">
                    <h2>Mitgliedschaft</h2>
                    <ul class="text-gray-200">
                        <li><a routerLink="/" class="hover:underline">Home</a></li>
                        <li>Mitgliedschaft</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Mitgliedschaft Inhalt -->
<section class="py-20 bg-white">
    <div class="container mx-auto px-4">
        <div class="max-w-3xl mx-auto text-center">
            <h2 class="text-3xl font-bold mb-4 text-gray-800">Werde Teil von HIGETO e.V.</h2>
            <p class="text-lg text-gray-600 mb-6">
                Als Mitglied unterstützt du unsere humanitäre Arbeit langfristig. Der Mitgliedsbeitrag beträgt nur <strong>20 € im Jahr</strong>.
            </p>
        </div>

        <div class="max-w-2xl mx-auto bg-gray-100 p-8 rounded-2xl shadow-md">
            <h3 class="text-xl font-semibold mb-4 text-gray-700">Deine Vorteile:</h3>
            <ul class="list-disc pl-6 text-gray-600 space-y-2">
                <li>Regelmäßige Informationen zu Projekten</li>
                <li>Stimmrecht bei Versammlungen</li>
                <li>Aktive Mitgestaltung und Engagement</li>
            </ul>

            <div class="mt-8 text-center">
                <a href="mailto:hgesundheit.togo@gmail.com" class="default-btn">
                    Mitgliedsantrag per E-Mail senden
                </a>
            </div>
        </div>
    </div>
</section>
<app-subscribe></app-subscribe>
